import ColumnsFilterButtonTable from '../../../ColumnsFilterButtonTable'
import PaginationSizeChooser from '../TableActions/components/PageSizeChooser'

const TABLE_ACTIONS_TYPE = {
  CUSTOM: 'CUSTOM',
  PLATFORM_COMPONENTS: 'PLATFORM_COMPONENTS',
  DEFAULT: 'DEFAULT',
  DROPDOWN: 'DROPDOWN'
}

const TABLE_ACTION_COMPONENTS = {
  ColumnsFilterButtonTable: ColumnsFilterButtonTable,
  PaginationSizeChooser: PaginationSizeChooser
}

export { TABLE_ACTIONS_TYPE, TABLE_ACTION_COMPONENTS }
